import { computed, inject, Service, signal } from '@angular/core'
import { PopupService } from '../popup-service/popup.service'

/** Tracks overlays that need the native status bar to use the active scrim surface. */
@Service()
export class OverlayStatusBarService {
  private readonly overlayCount = signal(0)
  private readonly overlays = inject(PopupService)
  readonly hasActiveOverlay = computed(() =>
    this.overlays.hasOverlays() ? this.overlays.topUsesScrim() : this.overlayCount() > 0
  )

  /** Registers an overlay until it is destroyed or removed. */
  openOverlay(): void {
    this.overlayCount.update(count => count + 1)
  }

  /** Removes one overlay registration without allowing the count to become negative. */
  closeOverlay(): void {
    this.overlayCount.update(count => Math.max(0, count - 1))
  }
}
